import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../assets/style/core.css"
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { faArrowUpFromBracket, faAward, faBrain, faCircleExclamation, faFaceSmileBeam, faFaceSmileWink, faFaceSurprise, faFlagCheckered, faGamepad, faGun, faMugHot, faPeopleGroup, faPhone, faRightToBracket, faRunning, faShuttleSpace, faSmileWink, faSurprise, faTrophy } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import gameImg from "../assets/img/gaming.png"

function Gaming() {
    useEffect(() => {
        AOS.init();
    }, []);
    return (
        <>
            <Navbar />
            <section>
                <div className='container'>
                    <div className='p-md-5 p-3'>
                        <h1 className='text-primary text-center mb-1 mt-4'>VIRTUFUSE - Unleash the gamer within</h1>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="hero-content darkBlue-text" data-aos="fade-right" data-aos-duration="1200">
                                    <p>Join us for an electrifying gaming event. Dive into a thrilling day packed with competitive tournament. Whether you're a seasoned pro or a casual gamer, there's something for everyone. Meet fellow gamers, challenge your skills, and experience the ultimate gaming atmosphere. 
Don't miss out on the learning and fun . Gear up and get ready to play!</p>
                                    <p> So, grab your controllers and join us for an unforgettable celebration of gaming culture. Get ready to level up your gaming experience!</p>
                                </div>
                            </div>
                            <div className='col-lg-6 d-flex justify-content-center align-items-center'>
                                <img src={gameImg} height={420} data-aos="fade-up" data-aos-duration="1800" className='img-ani' />
                            </div>
                        </div>
                        <h4 className='darkBlue-text'>Rules and Regulations</h4>
                        <ul>
                            <li><span class="darkBlue-text">Team should consist of 1 participant only.</span></li>
                            <li><span class="darkBlue-text">ID card of your college is compulsory.</span></li>
                            <li><span class="darkBlue-text">Judges descision is final</span></li>
                        </ul></div>
                </div>

                <div className='hero-wrapper'>
                    <div className="container">
                        <div className="p-md-5 text-center mt-5">
                            <div className="row">
                                <h1 className='mb-5 text-white mt-5'>Pre Requisite</h1>
                                <div className="col-sm" data-aos="zoom-in" data-aos-duration="1400">
                                     <p className="h5 mt-2 mb-4 text-white">Get Headphone, keyboard and mouse (optional)</p>
                                </div>
                                <div className="col-sm" data-aos="zoom-in" data-aos-duration="1000">
                                     <p className="h5 mt-2 mb-4 text-white">Controlled attitude on your controllers</p>
                                </div>
                                <div className="col-sm" data-aos="zoom-in" data-aos-duration="1800">
                                     <p className="h5 mt-2 mb-4 text-white">Must embrace the chaos with a smile</p>
                                </div>
                            </div>
                            <h1 className='mb-3 text-white mt-4 text-decoration-underline'>Contact / Help</h1>
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2 className='text-white mt-3'>Student Coordinator : </h2>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Mr. Harshit Vaidya - <a className="text-white me-3 btn btn-sm  btn-secondary" href="https://wa.me/918762203544"><FontAwesomeIcon icon={faWhatsapp} size="lg" /></a></h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Mr. Aditya S K - <a className="text-white me-3 btn btn-sm  btn-secondary" href="https://wa.me/918904671294"><FontAwesomeIcon icon={faWhatsapp} size="lg" /></a></h5>
                                </div>
                                <div className="col-lg-6">
                                    <h2 className='text-white mt-3'>Faculty Coordinator : </h2>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Prof.Shridevi K </h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Prof.Sunaina  </h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Prof.Annapurna  </h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Prof.Sanjay </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 className='text-center p-5 darkBlue-text text-decoration-underline'>Join us and unleash your gaming powers,
                    Where fun meets competition, and friendships are forged</h4>
            </section>
            <Footer />
        </>
    )
}

export default Gaming